document.addEventListener('DOMContentLoaded', () => {

  const el = document.querySelector('.js-flyingbar');
  const hero = document.querySelector('.js-hero');

  if (!el || !hero) return;

  let lastScroll = window.pageYOffset || window.scrollY;
  let ticking = false;
  const threshold = 10;

  const update = () => {
    const currentScroll = window.pageYOffset || window.scrollY;
    const diff = currentScroll - lastScroll;

    const heroBottom = hero.getBoundingClientRect().bottom;

    // JEŚLI JESTEŚ NAD HERO (hero jeszcze widoczny)
    if (heroBottom > 0) {
      document.documentElement.classList.remove('show-flyingbar');
      lastScroll = currentScroll;
      ticking = false;
      return;
    }

    // POZA HERO → sterujemy scroll direction
    if (Math.abs(diff) > threshold) {
      if (diff > 0) {
        document.documentElement.classList.add('show-flyingbar');
        // scroll w dół → chowaj
        // document.documentElement.classList.remove('show-flyingbar');
      } else {
        // scroll w górę → pokazuj
        //document.documentElement.classList.add('show-flyingbar');
      }

      lastScroll = currentScroll;
    }

    ticking = false;
  };

  const onScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });

}, false);